var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5319 19.6262C16.0023 19.6262 19.6262 16.0023 19.6262 11.5319C19.6262 7.06147 16.0023 3.4375 11.5319 3.4375C7.06147 3.4375 3.4375 7.06147 3.4375 11.5319C3.4375 16.0023 7.06147 19.6262 11.5319 19.6262Z",
    stroke: "black",
    strokeOpacity: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2563 17.2563L18.1982 18.1982M18.1982 18.1982V20.5551L24.2057 26.5626L26.5626 24.2057L20.5551 18.1982H18.1982Z",
    stroke: "black",
    strokeOpacity: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.081d30d56c5f4060c29199b1a30e16f6.svg";
export { ForwardRef as ReactComponent };